export default __webpack_public_path__ + "static/media/Delivery_Tracking.a35e115c.svg";